import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface FilterIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const FilterIcon: React.FC<FilterIconProps> = ({ color, width = 18, height = 18, className }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 4.5H15.75M4.5 9H13.5M6.75 13.5H11.25"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="3.75" cy="4.5" r="1.5" fill={currentColor} />
      <circle cx="14.25" cy="9" r="1.5" fill={currentColor} />
      <circle cx="5.25" cy="13.5" r="1.5" fill={currentColor} />
    </svg>
  );
};

export default FilterIcon;
